// The camera accent hue (cyan). Single source of truth for the color the three
// camera surfaces must agree on: the camera event-graph nodes (CameraNodes), the
// dev camera-cage gizmo (Scene), and the LiveTunePanel CAMERA section. There is
// no shared node-visuals registry to hang this on, so it lives here — small and
// camera-scoped — rather than being re-declared in each file. Re-declaring it was
// a drift risk: change the accent in one place, miss another, and the viewport
// gizmo no longer matches the nodes.
export const CAMERA_ACCENT = '#60c0e0'
